module.exports = __webpack_public_path__ + "img/color-picker-2_en.9dff522.jpg";